// extracted by mini-css-extract-plugin
module.exports = {"footerMain":"Footer_footerMain__5yv_j","footersvgimg":"Footer_footersvgimg__lx0hj","footerImg":"Footer_footerImg__kSYtf"};